import styled, { css } from 'styled-components';
import React, { useRef, useState, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import MenuButton from './MenuButton';
import useClickOutside from '../../hooks/useClickOutside';

const ARROW_CONFIG = {
  bottom: 13, // The 'bottom' CSS property
  size: 10, // The border-width size
};

const Container = styled.div`
  width: 100%;
  height: 60%;

  ${(props) =>
    !!props.width &&
    css`
      width: ${props.width};
    `}
`;

const MenuBody = styled.div`
  position: fixed;
  z-index: 100;
  transform: translate(-100%, -100%);

  top: ${(props) => props.coords.top}px;
  left: ${(props) => props.coords.left}px;

  > div {
    padding: 5px;
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    width: 200px;
    border-radius: 10px;
    border: solid var(--grey100) 1px;

    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: ${ARROW_CONFIG.bottom}px;
      right: -15px;
      border-style: solid;
      border-width: ${ARROW_CONFIG.size}px ${ARROW_CONFIG.size}px 0 ${ARROW_CONFIG.size}px;
      border-color: var(--white) transparent transparent transparent;
      transform: rotate(270deg);
    }
  }
`;

export const Menu = ({ children, ...props }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useClickOutside(ref, () => setShow(false));

  const toggleMenu = () => {
    if (!show && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const totalOffset = ARROW_CONFIG.bottom + ARROW_CONFIG.size;
      setCoords({
        top: rect.top + rect.height / 2 + totalOffset,
        left: rect.left - rect.width / 2,
      });
    }
    setShow(!show);
  };

  useLayoutEffect(() => {
    if (show) {
      const handleScroll = () => setShow(false);
      window.addEventListener('scroll', handleScroll, true);
      return () => window.removeEventListener('scroll', handleScroll, true);
    }
  }, [show]);

  return (
    <Container className="check-test" ref={ref}>
      <MenuButton onClick={toggleMenu} />
      {show &&
        createPortal(
          <MenuBody {...props} coords={coords}>
            <div>{children}</div>
          </MenuBody>,
          document.body
        )}
    </Container>
  );
};

export default Menu;
